import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a872a72755b8c0014978737_1788730629465_ea8b5b43/nexosource/src/app/search/page.tsx");
